/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Atelier_PoInputs */

const en_scene_atelier_po = /** @type {(inputs: Scene_Atelier_PoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase order from Tomorrow`)
};

/**
* | output |
* | --- |
* | "Purchase order from Tomorrow" |
*
* @param {Scene_Atelier_PoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_atelier_po = /** @type {((inputs?: Scene_Atelier_PoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Atelier_PoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_atelier_po(inputs)
});